import { makeStyles } from '@material-ui/core/styles';
import { yellow, orange } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => {
  return {
    status: {
      borderRadius: 2,
      color: '#fff',
      fontWeight: 500,
      padding: '6px 16px',
      fontSize: '12px',
      position: 'relative',
      backgroundColor: theme.palette.general.lightGrey,
    },
    assigned: {
      backgroundColor: theme.palette.status.active,
    },
    unassigned: {
      backgroundColor: theme.palette.error.main,
    },
    archived: {
      backgroundColor: theme.palette.status.main,
    },
    pending: {
      backgroundColor: theme.palette.primary.main,
    },
    enabled: {
      backgroundColor: theme.palette.status.active,
    },
    active: {
      backgroundColor: theme.palette.status.active,
    },
    disabled: {
      backgroundColor: theme.palette.error.main,
    },
    deleted: {
      backgroundColor: theme.palette.error.main,
    },
    suspended: {
      backgroundColor: theme.palette.error.main,
    },
    blocked: {
      backgroundColor: theme.palette.error.main,
    },
    reserved: {
      backgroundColor: theme.palette.primary.main,
    },
    reserved_late: {
      backgroundColor: yellow[600],
    },
    inprogress: {
      backgroundColor: theme.palette.statuses.inProgress,
    },
    inprogress_late: {
      backgroundColor: theme.palette.success.main,
    },
    completed: {
      backgroundColor: theme.palette.status.active,
    },
    endexchange: {
      backgroundColor: theme.palette.statuses.pendingApproval,
    },
    startexchange: {
      backgroundColor: theme.palette.statuses.pendingApproval,
    },
    inshop: {
      backgroundColor: theme.palette.general.lightGrey,
    },
    available: {
      backgroundColor: orange[600],
    },
    paid: {
      backgroundColor: theme.palette.status.active,
    },
    overpaid: {
      backgroundColor: theme.palette.status.active,
    },
    unpaid: {
      backgroundColor: theme.palette.status.main,
    },
    cancelled: {
      backgroundColor: theme.palette.statuses.cancelled,
    },
  };
});

const outlineUseStyles = makeStyles((theme) => {
  return {
    status: {
      fontSize: '12px',
      position: 'relative',
      '&::before': {
        content: "''",
        position: 'absolute',
        width: 5,
        height: 5,
        borderRadius: '50%',
        left: '-10px',
        bottom: '5px',
      },
    },
    pending: {
      color: theme.palette.primary.main,
      '&::before': {
        backgroundColor: theme.palette.primary.main,
      },
    },
    active: {
      color: theme.palette.success.main,
      '&::before': {
        backgroundColor: theme.palette.success.main,
      },
    },
    suspended: {
      color: theme.palette.error.main,
      '&::before': {
        backgroundColor: theme.palette.error.main,
      },
    },
    blocked: {
      color: theme.palette.error.main,
      '&::before': {
        backgroundColor: theme.palette.error.main,
      },
    },
    reserved: {
      color: theme.palette.primary.main,
      '&::before': {
        backgroundColor: theme.palette.primary.main,
      },
    },
    reserved_late: {
      color: yellow[600],
      '&::before': {
        backgroundColor: yellow[600],
      },
    },
    inprogress: {
      color: theme.palette.statuses.inProgress,
      '&::before': {
        backgroundColor: theme.palette.statuses.inProgress,
      },
    },
    inprogress_late: {
      color: theme.palette.success.main,
      '&::before': {
        backgroundColor: theme.palette.error.main,
      },
    },
    completed: {
      color: theme.palette.general.lightGrey,
      '&::before': {
        backgroundColor: theme.palette.general.lightGrey,
      },
    },
    inshop: {
      color: theme.palette.general.lightGrey,
      '&::before': {
        backgroundColor: theme.palette.general.lightGrey,
      },
    },
    available: {
      color: orange[600],
      '&::before': {
        backgroundColor: orange[600],
      },
    },
  };
});

const textLabelUseStyles = makeStyles((theme) => {
  return {
    status: {
      fontSize: '13px',
      position: 'relative',
      fontWeight: 'bold',
    },
    assigned: {
      color: theme.palette.status.active,
    },
    unassigned: {
      color: theme.palette.error.main,
    },
    archived: {
      color: theme.palette.status.main,
    },
    pending: {
      color: theme.palette.primary.main,
    },
    active: {
      color: theme.palette.success.main,
    },
    suspended: {
      color: theme.palette.error.main,
    },
    blocked: {
      color: theme.palette.error.main,
    },
    reserved: {
      color: theme.palette.primary.main,
    },
    reserved_late: {
      color: yellow[600],
    },
    inprogress: {
      color: theme.palette.statuses.inProgress,
    },
    inprogress_late: {
      color: theme.palette.success.main,
    },
    completed: {
      color: theme.palette.general.lightGrey,
    },
    inshop: {
      color: theme.palette.general.lightGrey,
    },
    inshop: {
      color: theme.palette.grey[500],
    },
    retired: {
      color: theme.palette.grey[500],
    },
    inactive: {
      color: theme.palette.grey[500],
    },
    available: {
      color: orange[600],
    },
    needsapproval: {
      color: orange[600],
    },
    customerdeletion: {
      color: orange[600],
    },
    label: {
      color: '#111',
      fontWeight: '400',
    },
    deleted: {
      color: theme.palette.error.main,
    },
    paid: {
      color: theme.palette.status.active,
    },
    overpaid: {
      color: theme.palette.status.active,
    },
    unpaid: {
      color: theme.palette.status.main,
    },
    cancelled: {
      color: theme.palette.statuses.cancelled,
    },
    requested: {
      color: orange[600],
    },
    rejected: {
      color: orange[600],
    },
    accepted: {
      color: orange[600],
    },
    deleted: {
      color: orange[600],
    },
  };
});

export { useStyles, outlineUseStyles, textLabelUseStyles };
